import type { EntryPointPayload, EntryPointPayloadType, LifeRequestPayload } from './types';
import type { Platform } from '../platform/Platform';
import { isEntryPointPayloadExpired } from './isEntryPointPayloadExpired';
import type { App } from '../App';

const payloadHandlers: Record<EntryPointPayloadType, (payload: EntryPointPayload, app: App) => void> = {
  lifeRequest: (_payload: LifeRequestPayload, app: App) => {
    app.resources.addLifeQuestReward();
  },
};

export function handleEntryPointData(platform: Platform, app: App, payload: EntryPointPayload): void {
  const invalidFields = getInvalidFields(payload, platform);
  const { stateController } = app;

  if (invalidFields.length > 0) {
    console.warn(`EntryPointPayload has the following invalid fields "${invalidFields.join(',')}"`);
    return;
  }

  if (stateController.hasEntryPayload(payload.uid)) {
    console.warn(`EntryPointPayload with uid:"${payload.uid}" has already been claimed"`);
    return;
  }

  if (isEntryPointPayloadExpired(payload)) {
    console.warn('EntryPointPayload is expired');
    return;
  }

  if (!payloadHandlers[payload.payloadType]) {
    console.warn(`No handler exists for EntryPointPayload of type "${payload.payloadType}"`);
    return;
  }

  payloadHandlers[payload.payloadType](payload, app);

  stateController.addEntryPayload({
    uid: payload.uid,
    timestamp: payload.timestamp,
  });
}

function getInvalidFields(payload: EntryPointPayload, platform: Platform): string[] {
  const fields: string[] = [];
  if (!('uid' in payload) || typeof payload.uid !== 'string') fields.push('uid');
  if (!('timestamp' in payload) || typeof payload.timestamp !== 'number') fields.push('timestamp');
  if (!('senderId' in payload) || payload.senderId === platform.getCurrentPlayer().id) fields.push('senderId');
  if (!('payloadType' in payload) || typeof payload.payloadType !== 'string') fields.push('payloadType');
  return fields;
}
